export default {
  'cancel': '@:terms.cancel',
  'client': '@:terms.client',
  'reset': '@:terms.reset',
  'apply': '@:terms.apply',
  'title': '@:terms.client 선택',
  'placeholder': '@:terms.client @:terms.search',
  'empty-search': '@:terms.search 결과가 없습니다.',
}
